import { useState } from 'react'
import { useApiClient, UseProjectsParams } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export const useDownloadFieldReports = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const doExport = async ({ ...params }: UseProjectsParams) => {
    const queryParams = new URLSearchParams()

    if (params.search) queryParams.append('search', params.search)
    if (params.status) queryParams.append('status', params.status)
    if (params.exclude_status)
      queryParams.append('exclude_status', params.exclude_status)

    if (params.researchers)
      queryParams.append('researchers', params.researchers)

    if (params.project_leader)
      queryParams.append('project_leader', params.project_leader)

    setLoading(true)
    try {
      const response = await client.get<Blob>(
        `/projects/download_field_reports/?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response, { type: 'application/zip' })
    } finally {
      setLoading(false)
    }
  }

  return { doExport, loading }
}
